import { useMemo } from "react";
import useNavigate from "core/hooks/useNavigate";
import ReviewDraftChanges from "./ReviewDraftChanges";
import ReviewSummary from "./ReviewSummary";
import { Row } from "core/styles";
import Button from "core/components/Button";
import { LEGEND_VARIANTS, PRODUCT_BUNDLES } from "../constants";
import Tabs from "core/components/Tabs/Tabs";
import { LegendChip } from "core/components/LegendChip";
import {
  faArrowRotateLeft,
  faArrowsRotate,
  faCircleCheck,
  faCircleX,
} from "@fortawesome/pro-regular-svg-icons";
import Typography from "core/components/Typography";

const DeploymentReview = ({
  products,
  productsEnabled,
  getDynamicProduct,
  handleSubmit,
  isSubmitting,
  isDisabled,
  isLoading,
  previousData,
  updatedProducts,
  filteredBundles,
  deploymentStatus,
}) => {
  const navigate = useNavigate();

  const formHasError = useMemo(() => {
    return Object.values(products).some((product) => product.hasError);
  }, [products]);

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 10,
        }}
      >
        <Tabs
          type="content"
          basis="dynamic"
          items={[
            {
              id: "license-draft",
              title: "New Changes",
              content: (
                <div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-end",
                      gap: "8px",
                    }}
                  >
                    <Typography variant="sub-text" noMargin>
                      Legend:
                    </Typography>

                    <LegendChip
                      text="Updated"
                      rightIcon={faArrowsRotate}
                      intent={LEGEND_VARIANTS.MODIFIED}
                    />
                    <LegendChip
                      text="Added"
                      rightIcon={faCircleCheck}
                      intent={LEGEND_VARIANTS.POSITIVE}
                    />
                    <LegendChip
                      text="Removed"
                      rightIcon={faCircleX}
                      intent={LEGEND_VARIANTS.NEGATIVE}
                    />
                  </div>
                  <ReviewDraftChanges
                    bundles={filteredBundles}
                    products={updatedProducts}
                    productsEnabled={productsEnabled}
                    getDynamicProduct={getDynamicProduct}
                    handleSubmit={handleSubmit}
                    isSubmitting={isSubmitting}
                    isDisabled={isDisabled}
                    isLoading={isLoading}
                    previousData={previousData}
                  />
                </div>
              ),
            },
            {
              id: "license-summary",
              title: "License Summary",
              content: (
                <ReviewSummary
                  bundles={PRODUCT_BUNDLES}
                  products={products}
                  productsEnabled={productsEnabled}
                  getDynamicProduct={getDynamicProduct}
                  handleSubmit={handleSubmit}
                  isSubmitting={isSubmitting}
                  isDisabled={isDisabled}
                  isLoading={isLoading}
                  deploymentStatus={deploymentStatus}
                  isDirty={true}
                />
              ),
            },
          ]}
        />
      </div>

      <Row
        style={{ justifyContent: "flex-end", gap: "20px" }}
        data-test="button-row"
      >
        <Button
          variant="outlined"
          style={{ maxWidth: "fit-content" }}
          onClick={() => navigate("../configure", { state: { from: "route" } })}
          disabled={isSubmitting}
        >
          Back
        </Button>
        <Button
          width="200px"
          isLoading={isSubmitting}
          onClick={handleSubmit}
          disabled={isDisabled || isSubmitting || formHasError}
          data-test="submit-button"
        >
          Deploy License
        </Button>
      </Row>
    </>
  );
};

export default DeploymentReview;
